import { render } from "./FechaVence.vue?vue&type=template&id=f0199998"
import script from "./FechaVence.vue?vue&type=script&lang=js"
export * from "./FechaVence.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__